import { useRef, useContext, useEffect, useState } from 'react';

import styles from './TopicsDetailsComponents.module.css';

import { GlobalContext } from "../../../contexts/globalContext";
import { ProjectDetailsContext } from "../../../contexts/projectDetailsContext";
import { AddConferenceContext } from "../../../contexts/addConferenceContext";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons';

import DetailsCardComponent from '../../popup/conferenceDetails/DetailsCardComponent';
import InitialsCircleComponent from '../../commons/InitialsCircleComponent';
import DarkButtonComponent from '../../commons/DarkButtonComponent';
import MobileQRComponent from './MobileQRComponent'

import AddTopicIcon from '../../../graphics/Popups/Icon Conferinta Add.png';


const TopicsDetailsComponents = () => {


    const { socketRef, currentUser, currentParticipant, appWidth, appHeight } = useContext(GlobalContext);
    const { editConference, setEditConference } = useContext(ProjectDetailsContext);
    const {
        addNewTopic,
        selectedTopic,
        selectedModerator,
        setAddModerator,
        setAddNewTopic,
        setSelectedTopic,
        setOpenFiles,
        openFilesRef,
        openFiles,
        setDeleteClicked,
        setSelectedModerator
    } = useContext(AddConferenceContext);

    const isDeleteRef = useRef(null);
    const deleteRef = useRef();
    const subdeleteRef = useRef()
    const topicRefs = useRef({});
    const lastScrollY = useRef(0);
    const justExtended = useRef(false)

    const [extended, setExtended] = useState(null);
    const [indexSelected, setIndexSelected] = useState(null);
    const [topQr, setTopQr] = useState(210);
    const [heightQr, setHeightQr] = useState(370);
    const [isAdministrator, setIsAdministrator] = useState(null);

    const oxDivider = window.innerWidth / appWidth;
    const oyDivider = window.innerHeight / appHeight;

    useEffect(() => {
        setIsAdministrator(currentUser?.role.toLowerCase() === "administrator" || currentParticipant);
        handleClickExtention(editConference.topics[0]._id, 0);
        handleClickOpenFiles(null, editConference.topics[0]);
    }, []);

    useEffect(() => {
        if (selectedModerator && selectedTopic && !addNewTopic) {
            socketRef.current.emit('CONFERENCE_UPDATE_TOPIC', {
                conferenceId: editConference._id,
                topicId: selectedTopic,
                newData: {
                    moderator: selectedModerator._id,
                },
            }, callback => {
                if (!callback.error) {
                    setEditConference((prev) => ({
                        ...prev,
                        moderators: callback.response.moderators,
                        topics: prev.topics.map((topic) =>
                            topic._id === selectedTopic._id ? callback.response.updatedTopic : topic
                        ),
                    }));
                    setSelectedModerator()
                }
            });
        }
    }, [selectedModerator, selectedTopic, addNewTopic, socketRef, editConference._id]);

    useEffect(() => {
        if (extended && topicRefs.current[extended]) {
            const element = topicRefs.current[extended];
            const rect = element.getBoundingClientRect();

            setHeightQr(rect.height / oyDivider + 140)
            setTopQr(rect.top / oyDivider - 70)

            justExtended.current = true

            setTimeout(() => {
                justExtended.current = false
            }, 200);
        }
    }, [extended]);

    const handleClickExtention = (id, index) => {
        setExtended(id);
        setIndexSelected(index);
    };

    const handleClickOpenFiles = (e, topic) => {
        if (e) {
            e.stopPropagation();
        }

        if (topic.subtopics) {
            setOpenFiles(topic)
        } else {
            let subtopicNew = topic
            subtopicNew["topicId"] = extended
            setOpenFiles(subtopicNew)
        }

        openFilesRef.current = topic;
    };

    const handleEditTopic = (e, topic) => {
        e.stopPropagation();
        setAddNewTopic(true);
        setSelectedTopic(topic);
    };

    const handleUpdateModerator = (e, topic) => {
        if (isAdministrator) {
            e.stopPropagation();
            setAddModerator(true);
            setSelectedTopic(topic);
        }
    };

    const handleDeleteTopic = (e, type, topic) => {
        e.stopPropagation();
        isDeleteRef.current = topic;
        var rect;
        if (type === 'topic') {
            rect = deleteRef.current.getBoundingClientRect();
        } else {
            rect = subdeleteRef.current.getBoundingClientRect();
        }

        let x = rect.x
        let y = rect.y

        if (x / oxDivider - 1024 + 739 > appWidth) {
            x = (appWidth - 760) * oxDivider
        }

        if (y / oyDivider + 255 > appHeight) {
            y = (appHeight - 275) * oyDivider
        }

        setDeleteClicked({
            shown: true,
            funct: confirmDelete,
            name: type,
            x: x + 90,
            y: y,
            onClose: () => setDeleteClicked(),
        });
    };

    const confirmDelete = () => {
        const topicToDelete = isDeleteRef.current;

        if (!topicToDelete) {
            console.error("No item to delete. isDeleteRef is null.");
            return;
        }


        socketRef.current.emit("CONFERENCE_DELETE_TOPIC", topicToDelete, editConference._id, (callback) => {
            if (!callback.error) {

                setEditConference((prev) => ({
                    ...prev,
                    topics: callback.response.updatedTopics,
                    moderators: callback.response.moderators,
                }));
                setSelectedTopic();
                setOpenFiles();
                openFilesRef.current = undefined;
                setDeleteClicked()
            }
        }
        );

        isDeleteRef.current = null;
    };

    const isModeratorOfTopic = (topic) => {
        return currentUser?._id === topic.moderator?._id || currentParticipant?._id === topic.moderator?._id;
    };

    const onScroll = (e) => {

        const currentScrollY = e.target.scrollTop;
        const deltaY = currentScrollY - lastScrollY.current;
        lastScrollY.current = currentScrollY;

        if (!justExtended.current) {
            setTopQr(topQr => topQr - deltaY)
        }

    }

    return (
        <div className={styles.component}>
            <div className={styles.qrColumn}>
                <MobileQRComponent top={topQr} height={heightQr} />
            </div>
            <div className={styles.topicsColumn}>
                {isAdministrator && (
                    <DarkButtonComponent style={{ width: '99%', position: 'absolute', top: 92, marginBottom: 40, zIndex: 10 }} onClick={() => { setAddNewTopic(true); setSelectedTopic(); }}>
                        Add Topic
                    </DarkButtonComponent>
                )}
                {editConference.topics.length > 0 ? (
                    <DetailsCardComponent title="Topics" indexSelected={indexSelected} onScroll={onScroll}>
                        {editConference.topics.map((topic, index) => (
                            <div key={topic._id} ref={el => (topicRefs.current[topic._id] = el)} style={{ width: "100%" }}
                                onClick={(e) => {
                                    handleClickExtention(topic._id, index);
                                    handleClickOpenFiles(e, topic);
                                }}>
                                <div className={styles.notExtended}>
                                    <div className={styles.index}>
                                        {index < 9 ? `0${index + 1}` : index + 1}.
                                    </div>
                                    <div style={{ color: openFiles?._id === topic._id ? "#33FFC8" : "", maxWidth: extended === topic._id ? "84%" : "95%", overflow: "hidden", 
                                    textOverflow: "ellipsis" }}>
                                        {topic.name}
                                    </div>
                                    {extended === topic._id && (
                                        <>
                                            <FontAwesomeIcon className={styles.iconButton} style={{ right: isAdministrator ? 160 : 60 }}
                                                icon={byPrefixAndName.fal["pen"]} onClick={(e) => handleEditTopic(e, topic)}
                                            />
                                            {isAdministrator && (<FontAwesomeIcon ref={deleteRef} className={styles.iconButton} style={{ right: 75 }}
                                                icon={byPrefixAndName.fal["trash"]} onClick={(e) => handleDeleteTopic(e, 'topic', topic._id)} />
                                            )}
                                        </>
                                    )}
                                    {(isAdministrator || isModeratorOfTopic(topic)) && (
                                        <FontAwesomeIcon
                                            className={styles.iconButton}
                                            style={{ color: openFiles?._id === topic._id ? "#33FFC8" : "" }}
                                            icon={byPrefixAndName.fas["chevron-right"]}
                                            onClick={(e) => {
                                                handleClickExtention(topic._id, index);
                                                handleClickOpenFiles(e, topic)
                                            }}
                                        />
                                    )}
                                    <div className={styles.details} style={{ color: isModeratorOfTopic(topic) ? "#FFFFFF" : "" }} >
                                        <FontAwesomeIcon className={styles.icon} icon={byPrefixAndName.fal["bookmark"]} />
                                        <label className={styles.text}>Subtopics:</label>
                                        <label className={styles.number}>{topic.subtopics?.length}</label>
                                        {(editConference.type !== 'Presentation') && (<div className={styles.moderatorInfo} style={{ color: isModeratorOfTopic(topic) ? "#33FFC8" : "" }}>
                                            <FontAwesomeIcon className={styles.icon} icon={byPrefixAndName.fal["microphone-stand"]} />
                                            <label className={styles.text}>Moderator:</label>
                                            <label className={styles.number}>{topic.moderator?.name}</label>

                                        </div>)}
                                    </div>
                                </div>
                                {extended === topic._id && (isAdministrator || isModeratorOfTopic(topic)) && (
                                        <div className={styles.extended} style={{ 
                                            borderTop: topic.subtopics.length > 0 ? '1px solid #5E547C' : 'none', marginTop: topic.subtopics.length > 0 ? 40 : 20, 
                                            borderBottom: editConference.type !== 'Presentation' ? '1px solid #5E547C' : 'none',
                                            paddingBottom: editConference.type === 'Presentation' ? 0 : '',
                                            display: editConference.type === 'Presentation' && topic.subtopics.length === 0 ? 'none' : '',
                                        }}>
                                            {topic.subtopics.length > 0 && <div className={styles.subtopics}>
                                                {topic.subtopics.length > 0 && topic.subtopics.map((subtopic) => (<div key={subtopic._id} className={styles.subtopic}
                                                    onClick={(e) => handleClickOpenFiles(e, subtopic)}>
                                                    {(isAdministrator || isModeratorOfTopic(topic)) && (<FontAwesomeIcon
                                                        className={styles.iconOpenFilesSubtopic} style={{ color: openFiles?._id === subtopic._id ? "#33FFC8" : "" }}
                                                        icon={byPrefixAndName.fas["chevron-right"]} />
                                                    )}
                                                    <div style={{ color: openFiles?._id === subtopic._id ? "#33FFC8" : "" }}>
                                                        {subtopic.name}
                                                    </div>
                                                </div>
                                                )
                                                )}
                                            </div>}
                                            {editConference.type !== 'Presentation' && (<div className={styles.moderator} onClick={(e) => handleUpdateModerator(e, topic)}>
                                                <FontAwesomeIcon className={styles.icon} icon={byPrefixAndName.fal['microphone-stand']} />Moderator
                                                <div key={topic.moderator._id} className={styles.participantCard} >
                                                    <InitialsCircleComponent name={topic.moderator.name} style={{ marginLeft: 25, height: 121, width: 121, border: "6px solid #0D0032", marginBottom: 10 }} />
                                                    <div className={styles.participantDetails}>
                                                        {topic.moderator.role}
                                                        <div className={styles.participantName}>{topic.moderator.name}</div>
                                                        {topic.moderator.function?.name} {topic.moderator.function ? "|" : ""} {topic.moderator.department?.name}
                                                    </div>
                                                </div>
                                            </div>
                                            )}
                                        </div>
                                    )}
                            </div>
                        ))}
                    </DetailsCardComponent>
                ) : (
                    <DetailsCardComponent title="Topics">

                        {isAdministrator ? (
                            <>
                                <div style={{ width: 2015, height: 1261, marginTop: 30, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <div className={styles.centered}>
                                        <img src={AddTopicIcon} alt="icon add" className={styles.imgAdd} onClick={() => setAddNewTopic(true)} />
                                        <label className={styles.labelCreate}>Create new topic</label>
                                        <label className={styles.labelTextBold}>
                                            Topics and moderators are mandatory for every conference. <br />
                                            Subtopics are optional and help organize content more effectively.
                                            <br />Start by clicking the Add Topic button to begin creating topics.
                                        </label>
                                    </div>
                                </div>
                            </>) : (
                            <div style={{ width: "100%" }}> No topics added yet.</div>
                        )}
                    </DetailsCardComponent>

                )}

                <div className={styles.shadowUp} />
                <div className={styles.shadowBottom} />
            </div>

        </div>
    );

};

export default TopicsDetailsComponents;
